
import { AnaColumn } from "../forms-template.service";


export const crmBancheGrid: AnaColumn[] = [

  {
    configuration:
    {
      service: 'crmBancheForm',

      api: 'banche',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'COD',
      nCol: 2,
      //ListaHP=H12&ListaHP=H2&ListaHP=H4&
    },

    itemType: "group", colCount: "1", class: "", caption: "Banche",
    data: [

      {
        type: 'campo',
        dataField: 'COD',
        colVisible: false,
        dataType: 'string',
        caption: 'Cod ID',
        colAlignment: 'left',
        colWidth: 50
      },
      {
        type: 'campo',
        dataField: 'DES',
        colVisible: true,
        dataType: 'string',
        caption: 'Banca',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'ABICAB',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice ABI.CAB',
        colAlignment: 'center',
        colWidth: 120
      },
      {
        type: 'campo',
        dataField: 'IND',
        colVisible: true,
        dataType: 'string',
        caption: 'Indirizzo',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'NUM',
        colVisible: true,
        dataType: 'string',
        caption: 'Civico',
        colAlignment: 'center',
        colWidth: 70
      },
      {
        type: 'campo',
        dataField: 'CAP',
        colVisible: true,
        dataType: 'string',
        caption: 'CAP',
        colAlignment: 'center',
        colWidth: 120
      },
      {
        type: 'campo',
        dataField: 'id_localita',
        colVisible: true,
        dataType: 'string',
        caption: 'Comune',
        colAlignment: 'left',
        lista: {
          dataSource: 'comuni',
          valueExpr: 'id',
          displayExpr: 'nome',
          wingap: false,
        }
      },
      {
        type: 'campo',
        dataField: 'id_provincia',
        colVisible: true,
        dataType: 'string',
        caption: 'Provincia',
        colAlignment: 'left',
        colWidth: 70,
        lista: {
          dataSource: 'province',
          valueExpr: 'id',
          displayExpr: 'sigla_automobilistica',
          wingap: false,
        }
      },



    ]
  },

];

export const crmBancheForm: AnaColumn[] = [

  {
    itemType: 'group',
    caption: 'Modifica Informazioni Banca ',
    class: '',
    colCount: 3,
    colSpan: 2,


    data: [
      {
        type: 'campo',
        dataField: 'COD',
        visible: false,
        dataType: 'string',
        caption: 'Codice ID',
        class: 'crm_banche_editor',
        nCol: 3,
        // validation: [{ type: "required", message: "Campo Obbligatorio" }],

      },
      {
        type: 'campo',
        dataField: 'DES',
        dataType: 'string',
        caption: 'Banca',
        class: 'crm_banche_editor',
        nCol: 7,
        maxLength: 35,
        acceptOnlyCharacters: "/[a-zA-Z.,:;'\\-s ]/",
        validation: [
          { type: "required", message: "Campo Banca è obbligatorio" },
          { type: "pattern", value: "^[a-zA-Z.,:;'\\-s ]+$", message: "Il campo Banca può avere solo lettere e punti" },
          { type: 'maxLength', value: 35, message: "Lunghezza massima campo Banca superata" },
        ],
      },
      {
        type: 'campo',
        dataField: 'ABICAB',
        dataType: 'string',
        caption: 'Codice ABI.CAB',
        class: 'crm_banche_editor',
        nCol: 3,
        maxLength: 11,
        acceptOnlyCharacters: "/[0-9.]/",
        validation: [
          { type: "required", message: "Campo Codice ABI.CAB è obbligatorio" },
          { type: "pattern", value: "^\\d{5}\\.\\d{5}$", message: "Il campo Codice ABI.CAB può avere solo numeri e un punto che li separa" },
          { type: 'maxLength', value: 11, message: "Lunghezza massima campo Codice ABI.CAB superata" },
        ],
      },

      { type: 'empty' },

      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'IND',
        dataType: 'string',
        caption: 'Indirizzo',
        class: 'crm_banche_editor',
        nCol: 8,
        maxLength: 35,
        acceptOnlyCharacters: "/[a-zA-Z0-9()/.,:;'\\-s ]/",
        validation: [
          { type: "required", message: "Campo Indirizzo è obbligatorio" },
          { type: "pattern", value: "^[a-zA-Z0-9/().,:;'\\-s ]+$", message: "Il campo Indirizzo può avere solo lettere, punti e spazi" },
          { type: 'maxLength', value: 35, message: "Lunghezza massima campo Indirizzo superata" },
        ],
      },
      {
        type: 'campo',
        dataField: 'NUM',
        dataType: 'string',
        caption: 'Civico',
        class: 'crm_banche_editor',
        nCol: 2,
        maxLength: 7,
        acceptOnlyCharacters: "/[a-zA-Z0-9/.,\\-s ]/",
        validation: [
          { type: "required", message: "Campo Civico è obbligatorio" },
          { type: 'maxLength', value: 7, message: "Lunghezza massima campo Civico superata" },
          { type: "pattern", value: "^[a-zA-Z0-9/.,\\-s ]+$", message: "Il campo Civico può avere solo lettere, numeri e punteggiatura" },
        ],
      },
      { type: 'empty' },
      /*  */
      {
        type: 'campo',
        dataField: 'id_regione',
        dataType: 'grid',
        showClearButton: false,
        visible: false,
        colVisible: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        caption: 'Regione',
        class: 'crm_banche_editor',
        nCol: 5,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          dataSource: 'regioni',
          service: '',
          autocomplete: true,
          caption: 'Lista Località',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Località',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'CAP',
        dataType: 'string',
        caption: 'CAP',
        class: 'crm_banche_editor',
        nCol: 2,
        maxLength: 5,
        acceptOnlyCharacters: "/[0-9]/",
        validation: [
          { type: "required", message: "Campo CAP è obbligatorio" },
          { type: "pattern", value: "^[0-9]+$", message: "Il campo CAP può avere solo numeri" },
          { type: 'maxLength', value: 5, message: "Lunghezza massima campo CAP superata" },
        ],
      },
      {
        type: 'campoSpecial',
        dataField: 'id_localita',
        dataType: 'string',
        caption: 'Comune',
        class: 'crm_banche_editor',
        nCol: 6,
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        editorType: '',
        validation: [
          { type: "required", message: "Campo Comune è obbligatorio" },
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          // costantValue: [
          //   { key: 'id_regione', value: 'id_regione' },

          // ],
          related: ['id_regione|id_regione', 'id_provincia|id_provincia', 'cap|CAP'],
          dataSource: 'comuni',
          service: '',
          autocomplete: false,
          caption: 'Lista Comune',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Comune',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'id_regione',
                dataType: '',
                caption: 'Codice Regione',
                allowEditing: true,
                colVisible: false,
              },
              {
                dataField: 'id_provincia',
                dataType: '',
                caption: 'Codice Provincia',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
              {
                dataField: 'cap',
                dataType: '',
                caption: 'Cap',
                allowEditing: true,
              },
              {
                dataField: 'codice_catastale',
                dataType: '',
                caption: 'Codice Catastale',
                allowEditing: true,
                colVisible: false
              },
            ],
          },
        },
      },

      {
        type: 'campoSpecial',
        dataType: '',
        dataField: 'id_provincia',
        caption: 'Provincia',
        class: 'disabileVisibile crm_banche_editor',
        nCol: 2,
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        disabled: true,
        dynamic: {
          valueExpr: 'id',
          // queryString: '?id_regione=$id_regione',
          // costantValue: [
          //   { key: 'id_regione', value: 'id_regione' }
          // ],
          displayExpr: 'nome',
          dataSource: 'province',
          campoTabRif: 'id',
          service: '',
          autocomplete: true,
          caption: 'Lista Province',
          filterStatic: "",
          // related: ['id_provincia|id_provincia'],
          componentType: 'dynamicGrid',
          /* buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Province',
            name: 'Reg',
            location: 'after',
          }, */
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 500,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,//per skip e top in query
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false,
                colAlignment: 'center'
              },
              {
                dataField: 'id_regione',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false,
                colAlignment: 'center'
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
              {
                dataField: 'sigla_automobilistica',
                dataType: '',
                caption: 'Sigla',
                allowEditing: true,
              },

            ],
          },
        },

      },

    ],
  },
]